
















































































































































import { Component, Vue } from "vue-property-decorator";
import SolicitacaoModel from "@/models/Solicitacao";
import moment from "moment";
import { Route } from "vue-router";
import { getModule } from "vuex-module-decorators";
import { store, UserModule } from "@/store";
import ProcessoModel, { ParteChaves } from "@/models/Processo";
import UsuarioFormulario, { DadosAlteracaoUsuario } from "@/components/UsuarioFormulario.vue";
import UserModel, { UserDb } from "@/models/User";
import EventBus, { DeclaredEvents, SnackBarEvent, SnackPriorityToColor } from "@/EventBus";
import ChatList from "@/components/Chat/ChatList.vue";
import ChatModel from "@/models/Chat";
import _debug from "debug";

const debug = _debug("Mediacao:views:processo:ProcessoCadastro.vue");

const userModule = getModule(UserModule, store);

Component.registerHooks([
    "beforeRouteEnter",
    // 'beforeRouteLeave',
    // 'beforeRouteUpdate' // for vue-router 2.2+
]);

@Component({
    components: { UsuarioFormulario, ChatList },
})
export default class ProcessoCadastro extends Vue {
    private solicitacao?: SolicitacaoModel;
    private processo: ProcessoModel | null = null;
    private formValid = false;
    private commingFromRoute?: Route;
    private loading = true;
    private parteUm: ParteChaves = ParteChaves.ParteUm;
    private parteDois: ParteChaves = ParteChaves.ParteDois;
    private podeEditar = false;
    private dialogEcerrarProcesso = false;
    private loggedUser: UserModel | null = null;

    private rules = {
        titulo: [(v: string) => !!v || "O título é obrigatório!", (v: string) => (v && v.length <= 40) || "O título deve ter no máximo 40 caracteres!"],
        resumo: [(v: string) => !!v || "A descrição é obrigatória!", (v: string) => (v && v.length <= 4000) || "A descrição deve ter no máximo 4000 caracteres!"],
    };

    private get isLoading() {
        return this.loading;
    }

    private get pauseButtonText() {
        let text = "Pausar";
        if (this.processo && this.processo.status === "pausado") {
            text = "Retomar";
        }
        return text;
    }

    private async created() {
        debug("ProcessoCadastro.created: id", this.$route.params.id);
        console.log("ProcessoCadastro.created");
        const user = await userModule.getUser;
        if (user) {
            this.loggedUser = user;
            this.podeEditar = user.hasRoleOf(["admin", "mediador"]);
        }
        if (this.$route.params.id === "novo") {
            const idSolicitacao = this.$route.params.solicitacao;
            if (!idSolicitacao) {
                this.processo = new ProcessoModel();
                this.loading = false;
            } else {
                try {
                    this.processo = await ProcessoModel.newFromSolicitacao(idSolicitacao);
                    this.loading = false;
                    debug("novo a partir da solicitação", this.solicitacao);
                    this.$router.replace(`/processo/${this.processo.id}`);
                } catch (error) {
                    console.error("Erro criando processo da solicitação!", error);
                }
            }
        } else {
            try {
                this.processo = await ProcessoModel.fetchById(this.$route.params.id, true);
                await this.processo.loadChats();
                this.loading = false;
            } catch (error) {
                console.error("Erro buscando Processo para editar!", error);
            }
        }
    }

    private get souOMediador() {
        if (this.processo && this.processo.partes && this.processo.partes.mediador && this.loggedUser && this.loggedUser.userDb) {
            return this.processo.partes.mediador.email === this.loggedUser.userDb.email;
        } else {
            return false;
        }
    }

    private get dataCriacaoFormatada() {
        if (this.processo && this.processo.created_at) {
            return moment(this.processo.created_at).format("DD/MM/YYYY - HH:mm");
        }
        if (this.solicitacao && this.solicitacao.created_at) {
            return moment(this.solicitacao.created_at).format("DD/MM/YYYY - HH:mm");
        }
        return "";
    }
    private cancelar() {
        this.$router.go(-1);
    }
    private async salvar() {
        const user = await userModule.getUser;
        if (this.processo && user.userDb) {
            const processoSalvo = await this.processo.save(user.userDb.email as string);
            debug("Salvou o processo", processoSalvo, this.processo);
            const event: SnackBarEvent = {
                message: "Processo Salvo com Sucesso",
                priority: SnackPriorityToColor.success,
            };
            EventBus.$emit(DeclaredEvents.snackBarMessage, event);
        }
    }

    private adicionarParte(parte: ParteChaves) {
        debug("adicionando parte", parte);
        console.log("dentro adiciona parte.");
        if (this.processo) {
            (this.processo.partes as any)[`p${parte.split("userP")[1]}`] = {} as UserDb;
        }
    }

    private cancelarEdicaoUsuario(dados: DadosAlteracaoUsuario) {
        debug("Cancelou edição da parte", dados);
        if (!dados.original.email && this.processo && this.processo.partes) {
            const key = `p${dados.parte.split("userP")[1]}`;
            (this.processo.partes as any)[key] = null;
        }
    }

    private async usuarioParteAlterado(dados: DadosAlteracaoUsuario) {
        debug("usuarioParteAlterado", dados);
        EventBus.$emit(DeclaredEvents.snackBarMessage, {
            message: "Dados da parte salvos com Sucesso",
            priority: SnackPriorityToColor.success,
        });
        if (!dados.original.email && this.processo && dados.usuario.email) {
            this.processo.setParte(dados.parte, dados.usuario.email);
            const processoSalvo = await this.processo.save();
            debug("Salvou o processo com a nova parte", processoSalvo, this.processo);
        }
    }

    private async removerParte(dados: DadosAlteracaoUsuario) {
        debug("removendo parte", dados);
        if (this.processo) {
            await this.processo.removeParte(dados.parte);
            // console.log("vai forçar o reload");
            // this.$router.go(0);
        }
    }

    private async adicionarChat() {
        debug("Adicionando novo chat!");
        if (this.processo) {
            this.processo.addChat();
        }
    }

    private visualizarChat(chat: ChatModel) {
        debug("Visualizar chat", chat);
        if (this.processo) {
            this.$router.push(`/processo/${this.processo.id}/chat/${chat.id}`);
        }
    }

    private encerrar() {
        this.dialogEcerrarProcesso = true;
    }
    private cancelarDialogoEncerrarProcesso() {
        this.dialogEcerrarProcesso = false;
    }

    private encerrarProcesso() {
        this.dialogEcerrarProcesso = false;
        if (this.processo) {
            this.processo.status = "encerrado";
            this.processo.save();
            this.$router.push(`/processos`);
        }
    }

    private pauseResume() {
        if (this.processo) {
            if (this.processo.status === "pausado") {
                this.processo.status = "aberto";
            } else {
                this.processo.status = "pausado";
            }
            this.processo.save();
        }
    }

    private debugProcesso() {
        debug("meu processo=", this.processo);
    }
}
